const PATHS = [
    "M0 196 C 220 118 460 276 720 200 C 980 124 1220 256 1440 172 L1440 320 L0 320 Z",
    "M0 232 C 260 152 520 298 780 228 C 1040 158 1240 272 1440 196 L1440 320 L0 320 Z",
    "M0 268 C 300 206 560 316 820 262 C 1080 212 1260 306 1440 238 L1440 320 L0 320 Z",
];

function Waves() {
    return (
        <div className="ibg-waves" aria-hidden="true">
            {PATHS.map((d, i) => (
                <svg key={i} className="ibg-waves__layer" viewBox="0 0 1440 320" preserveAspectRatio="none">
                    <path d={d} />
                </svg>
            ))}
        </div>
    );
}

export default Waves;
